<template>
<div>
  <div class="popupStyle-layout-2">
    <div v-if="$route.name != 'PaymentInfo'" class="success-icon"
      @click="ok" />
    <div v-else class="success-icon2"
      @click="ok" />
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 20C40.5 25.3043 38.3929 30.3914 34.6421 34.1421C30.8914 37.8929 25.8043 40 20.5 40C15.1957 40 10.1086 37.8929 6.35786 34.1421C2.60714 30.3914 0.5 25.3043 0.5 20C0.5 14.6957 2.60714 9.60859 6.35786 5.85786C10.1086 2.10714 15.1957 0 20.5 0C25.8043 0 30.8914 2.10714 34.6421 5.85786C38.3929 9.60859 40.5 14.6957 40.5 20ZM30.575 12.425C30.3964 12.247 30.1838 12.1069 29.9498 12.013C29.7159 11.9191 29.4654 11.8734 29.2133 11.8785C28.9613 11.8837 28.7128 11.9396 28.4829 12.0429C28.2529 12.1463 28.0462 12.2949 27.875 12.48L19.1925 23.5425L13.96 18.3075C13.6046 17.9763 13.1344 17.796 12.6487 17.8046C12.1629 17.8131 11.6995 18.0099 11.3559 18.3534C11.0124 18.697 10.8156 19.1604 10.8071 19.6462C10.7985 20.1319 10.9788 20.6021 11.31 20.9575L17.925 27.575C18.1032 27.7529 18.3154 27.893 18.549 27.9871C18.7825 28.0812 19.0326 28.1273 19.2844 28.1226C19.5361 28.118 19.7843 28.0627 20.0142 27.96C20.2441 27.8573 20.451 27.7094 20.6225 27.525L30.6025 15.05C30.9427 14.6962 31.1307 14.2232 31.126 13.7324C31.1213 13.2416 30.9244 12.7722 30.5775 12.425H30.575Z" fill="#00CD34"/>
    </svg>
    <div class="popupStyle-text-2" v-html="contents" />
    <div class="popupStyle-text-3" v-html="contentsWeak" />
    <div v-if="$route.name == 'PaymentInfo'" class="popupStyle-text-4">
      ※ 한도초과 또는 잔액부족으로 결제 실패시<br />안내드린 사은품 지급이  어렵습니다.<br />지급가능 상태를 꼭 확인해주세요.
    </div>
  </div>
  <div v-if="$route.name == 'PaymentInfo'" class="btn-bottom" @click="buttonMethod">
    확인
  </div>
  <div v-else class="btn-bottom" @click="customOK ? customOK() : ok()">
    확인
  </div>
</div>
</template>

<script>
export default {
  props: {
    contents: String,
    contentsWeak: String,
    buttonMethod: Function,
    customOK: Function,
  },
  methods: {
    ok () {
      history.back();
    }
  }
}
</script>
<style lang="scss">
  .success-icon {
    cursor: pointer;
    position: absolute;
    top: -65px;
    right: 0px;
    @include square( 4*$unit, 0 );
    float: right;
    z-index: 1;
    background-repeat: no-repeat;
    background-size: 1.3*$unit;
    background-image: url(/static/images/connection/close.png);
    background-position: center;
  }
  .success-icon2 {
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 0px;
    @include square( 4*$unit, 0 );
    float: right;
    z-index: 1;
    background-repeat: no-repeat;
    background-size: 1.3*$unit;
    background-image: url(/static/images/connection/close.png);
    background-position: center;
  }
</style>
